import styled from 'styled-components';

export const InningWrapper = styled.div`
  margin-bottom: 5px;
  .ReactCollapse--collapse {
    overflow: auto;
    width: 100%;
  }
  .ReactCollapse--content {
    padding-top: 5px;
    overflow: auto;
  }
  & + .inning {
    margin-top: 5px;
  }
`;
